import { Panel } from "@/components/ui/Panel";
import { Sparkline } from "@/components/charts/Sparkline";
import { cn } from "@/lib/cn";

interface KpiTileProps {
  label: string;
  value: string;
  sub?: React.ReactNode;
  spark?: number[];
  sparkColor?: string;
  icon?: React.ReactNode;
}

export function KpiTile({
  label,
  value,
  sub,
  spark,
  sparkColor,
  icon,
}: KpiTileProps) {
  return (
    <Panel className="p-4">
      <div className="flex items-start justify-between gap-2">
        <div className="eyebrow">{label}</div>
        {icon ? <span className="text-ink-faint [&_svg]:size-4">{icon}</span> : null}
      </div>
      <div className="mt-2">
        <div className="font-mono tabular text-[1.7rem] font-semibold leading-none text-ink">
          {value}
        </div>
        {sub ? <div className={cn("mt-1.5 text-xs")}>{sub}</div> : null}
      </div>
      {spark ? (
        <div className="mt-3">
          <Sparkline
            data={spark}
            color={sparkColor ?? "var(--color-brand)"}
            width={240}
            height={34}
          />
        </div>
      ) : null}
    </Panel>
  );
}
